"use client";

import React from "react";
import { Users, DollarSign, Calendar, TrendingUp } from "lucide-react";
import { CompanyInfoCard, InfoRow } from "./CompanyInfoCard";
import type { CompanyEntity } from "@/lib/types/company";
import { formatWholeCurrency } from "@west-tennessee-consulting/ui";

interface CompanyKeyFactsProps {
  company: CompanyEntity;
}

export function CompanyKeyFacts({ company }: CompanyKeyFactsProps) {

  const formatEmployeeSize = (size: any): string | null => {
    if (!size) return null;
    if (typeof size === "string") return size;
    if (typeof size === "object" && size.min !== undefined && size.max !== undefined) {
      return `${size.min}-${size.max}`;
    }
    return null;
  };

  // Falsy (0 / blank) stays hidden, as before — formatWholeCurrency would render "$0".
  const revenue = company.organization_revenue
    ? formatWholeCurrency(company.organization_revenue)
    : null;
  const employeeSize = formatEmployeeSize(company.employee_size);
  const createdDate = company.created_at ? new Date(company.created_at).toLocaleDateString() : null;
  const lastEnriched = company.last_enriched_at ? new Date(company.last_enriched_at).toLocaleDateString() : null;

  const hasAnyData = revenue || employeeSize || createdDate || lastEnriched;

  if (!hasAnyData) return null;

  return (
    <CompanyInfoCard title="Key Facts" icon={TrendingUp}>
      {revenue && (
        <InfoRow label="Annual Revenue" value={revenue} icon={DollarSign} />
      )}

      {employeeSize && (
        <InfoRow label="Employee Size" value={employeeSize} icon={Users} />
      )}

      {createdDate && (
        <InfoRow label="Added to System" value={createdDate} icon={Calendar} />
      )}

      {lastEnriched && (
        <InfoRow label="Last Enriched" value={lastEnriched} icon={TrendingUp} />
      )}
    </CompanyInfoCard>
  );
}
